import { FeedProvider, EventType, ErrorCode } from "../commons/Constants";

// Re-export for Yahoo module consumers
export { EventType, ErrorCode };
import postEvent, { createBaseLanderEvent } from "../commons/LanderEvent";
import { Settings } from "../config";

export interface YahooEventOptions {
  yahooApiMessage?: string;
  errorCode?: string;
  rsTerms?: string;
  searchQuery?: string;
}

export function sendYahooEvent(
  eventType: string,
  landerConfig: any,
  options?: YahooEventOptions
) {
  const yahooEvent = createBaseLanderEvent(eventType, landerConfig);
  yahooEvent.feedProvider = FeedProvider.YAHOO;

  if (options?.yahooApiMessage) {
    yahooEvent.yahooApiMessage = options.yahooApiMessage;
  }
  if (options?.errorCode) {
    yahooEvent.errorCode = options.errorCode;
  }
  if (options?.rsTerms) {
    yahooEvent.rsTerms = options.rsTerms;
  }
  if (options?.searchQuery) {
    yahooEvent.searchQuery = options.searchQuery;
  }

  postEvent(Settings.EVENT_PUBLISH_API, yahooEvent);
}
